// ═══════════════════════════════════════════════════════════════
// OpenGov EMC — Ignatius API Client
// All calls go through the Cloudflare Worker proxy
// ═══════════════════════════════════════════════════════════════

export const WORKER_URL = import.meta.env.DEV
  ? (import.meta.env.VITE_WORKER_BASE || 'https://ogemc-worker.ogemc.workers.dev')
  : '/api/worker';
const API = `${WORKER_URL}/api/ignatius`;
export const ORIGIN = 'https://apps.opengov.com';

// ── Ignatius Table Keys ────────────────────────────────────────
export const TABLES = {
  // Shared
  incidents:      '7pyjexwg1',
  activityLog:    'e3hw4zba4',
  roster:         'keowpjyg6',   // Blackboard users table

  // HotWash
  observations:   '95jnhplq1',
  aiInsights:     'eb4n6onq6',

  // Handoff
  handoffMeta:    '2jn8eara2',
  positions:      'vqzrh4fq4',
  handoffNotes:   'tohix2zw7',
  actionItems:    'rvewkulq7',
  handoffTemplates: 'sliz4fwa8',

  // GeoOps (formerly Perimeter)
  perimeterIncidents: '2j9opxzw3',
  perimeterPoints:    'uz6fw1vq6',
  perimeterClosures:  '9qxvohjw6',
  perimeterBriefings: '3stfiyva4',
  geoopsZones:        'xaumufzq4',

  // Battle Rhythm
  brMeta:       'v4iae0uq5',
  brEvents:     '2mvm76pw2',
  brTemplates:  '1cdj2v0q1',

  // RollCall
  personnel:    '4zb5repg4',
  rcEvents:     'lwhczl2w1',
  rcCheckins:   'lvb1lcrq5',

  // PACE
  paceProfiles:     'empeq6ga8',
  callDowns:        '9hwzgbjw1',
  callDownResponses:'qrnky6ew6',
  callDownTemplates:'tkdzftpw5',
  pacePlans:        'l7dzvolg5',
  pacePlanEntries:  'dhdvsisw2',

  // Impact
  impactAssessments:      'dxzn49tg5',
  impactDetails:          'i3wnxjfw6',
  impactExtras:           'th2hjwpa6',
  impactPhotos:           'ocrmes5w3',
  impactSelfReports:      'edwqxuiq2',
  impactSelfReportAnswers:'mx44bo2a8',

  // Intake
  individuals:      'rduintoa7',
  individualDetails:'blbp1mma1',
  triageHistory:    '7uv1zwtw1',
  discharges:       'zvfn2uba2',
  propertyItems:    'z93vh1za2',
  documents:        'v3mt5ula1',
  categories:       'ibv01sdg1',

  // RBAC
  roles:        'a4joafhw4',
  userRoles:    '4tvbyvig6',

  // File Library
  appSettings: '5srcyyyw4',

  // VolunteerOS
  volunteers:       'nlkym2sw7',
  volEvents:        'oowkk67g5',
  volAssignments:   'xmzeqpog6',

  // Blackboard
  trainings:        '15jrrovq1',
  trainingRecords:  '5bwm7scw6',
  classrooms:       'x5rmpxfa6',
  certificates:     'xts8cwkw4',
  positionPlans:    '7xaku7og7',
  assignments:      'wpwmoppq2',

  // MainStreet
  msOrganizations:    '74h4jcpa8',
  msStatusChecks:     'ewyddu8w2',
  msStatusResponses:  '0utuicea8',
  msDamageReports:    'cknnm3fg3',
  msResourceOffers:   '1e2aqjhw2',
  msPosts:            't2s4wxia4',
  msFacilities:       '5aw74wag4',
  msContacts:         '4w2u3jmw4',
  msOrgLists:         'u8q8yeyg8',
  msReentryAuths:     '3h3ynavq3',
  msReentryPasses:    'mmeail8g5',

  // Debris ADMS
  debrisZones:          'lpjrim4q4',
  debrisContractors:    '3rqtj15q1',
  debrisCrews:          'pg3p99pq6',
  debrisTrucks:         'ke2t6dsw2',
  debrisLoadTickets:    'eiuluydg7',
  debrisDisposalSites:  'ywbav2ra5',
  debrisPhotos:         '8rj4yhgq4',
  debrisAuditLog:       'yevsi7ag4',
  debrisDocuments:      'mlurgmjg6',
  debrisInvoices:       'uay4jvba7',
  debrisRequests:       'xw5r0d6q1',
  debrisMonitors:       'd3h36swq3',
  debrisRateSchedules:  '6qcrz0ug8',
  debrisRightOfEntry:   'une3afpa1',
  paMitigationProposals: 'gltgmajw4',

  // Shelter Management
  shelters:              'x3m9nk7g8',
  survivors:             '28kh7ttq7',
  shelterFamilies:       'pcivneow8',
  shelterPets:           'mf1k1caa5',
  shelterVehicles:       'sgr24kbg2',
  triageQuestions:       'flngpx0q2',
  triageAnswers:         '3tner5sq3',
  medicalLog:            'ye2ohqkg2',
  shelterTransfers:      'b3nxaqma6',
  shelterProperty:       'cvylnx4q7',
  shelterIncidents:      'qblisycq4',
  shelterReferrals:      'qf0inapw5',
  shelterSupplies:       'w6m5vdbq4',
  reunification:         'dspl7qcg3',

  // PA Grants
  paOrganizations:     'n1guuolw4',
  paDisasters:         '4w1pv3ga3',
  paDamageInventory:   'qlsr3cfa3',
  paProjects:          'ql1b8dqq1',
  paProjectCosts:      'douexwxg7',
  paForceAccountLabor: 'e6i8giva8',
  paForceAccountEquip: 'pubpcjgg6',
  paMaterials:         'twjaha9q8',
  paContracts:         '4vfv1ljq4',
  paRentedEquipment:   'orzlqlig3',
  paDonatedResources:  'sc7rfbgw1',
  paInsurance:         'i3tu5gkg5',
  paCompliance:        'd678x2wg7',
  paDocuments:         'mbecrd4a4',
  paTimelineEvents:    '4sm2t3uq6',
  paNotes:             'ne7f1q5w1',
  paTimeExtensions:    'kdot6dua2',
  paReimbursementRequests: 'yuqknqww3',
  paLaborEmployees:    '3ui20eha5',
  paChecklistTemplates: 'tupo3w8g3',

  // Workflows
  workflowTemplates:   'vk62f18a2',
  workflowInstances:   'qbgrb5hg5',
  workflowSteps:       'tqgflt1w1',

  // Forms
  formTemplates:       '3ketghqw3',
  formResponses:       'bgfirgcw5',
} as const;

// ── Field Keys (per table) ─────────────────────────────────────
export const FIELDS = {
  incidents: {
    name: 'mxkjwdtw7',
    incidentType: 'rice6zsg7',
    status: 'jfphpc3g3',
    location: 'l2o7bjmq2',
    latitude: 'gspf0jqa1',
    longitude: 'jsyl4iaa6',
    description: 'fardwajg4',
    commander: 'x1afkrnw3',
    startDate: 'oprfbaba7',
    createdByName: '8ymhp0ag4',
  },
  activityLog: {
    incidentId: '6z4hr0cq1',
    module: 'riwdqtgg4',
    action: 'dh8h6z8g8',
    actorName: '8azw6axw3',
    actorEmail: '0hnlw7oa4',
    targetType: 'zkv5v7qg4',
    targetId: 'v1wfyzdw2',
    details: 'ikpnycoa7',
  },
  observations: {
    incidentId: 'tvtvfavg3',
    tier: '7i60p0ag8',
    title: 'd1xbchvq7',
    description: '6rhbkq2q5',
    category: 'rbdyxe0g2',
    phase: 'gu0xdkoa7',
    suggestedRemedy: 'i097xwag7',
    isAnonymous: '2rzdi9dw2',
    submittedBy: 'awcgqzka6',
  },
  handoffMeta: {
    name: 'oxw7uhdq3',
    eventType: 'gxjige7w8',
    status: 'akgpvbmq6',
    description: 'ck98ghdg5',
    aiBriefing: 'tttlt5bq4',
    aiPriorities: 'ryj45kmg5',
    creatorName: 'tavwjzmg3',
    creatorEmail: 'z0jaq9gq1',
  },
  positions: {
    eventId: 'snce7uuw6',
    positionName: 'bi65cr1a5',
    shortName: 'pyhjbghw5',
    sortOrder: 'q0enb0tg2',
    status: 'zb3kyotw3',
    dayUserName: 'n7mkvqsw7',
    dayUserEmail: 'wd7qd6eg2',
    nightUserName: '1ic4cozg3',
    nightUserEmail: 'mb1cfvsq7',
  },
  handoffNotes: {
    eventId: 'ysm5qqmw5',
    positionId: 'dgukv3rg7',
    positionName: 'thfhao2w1',
    status: 'zhzvwvhw5',
    fromShift: 'jkz8piag8',
    toShift: 'xm51q2ba1',
    shiftDate: 'uuryu7ya4',
    sections: 'hnkagl7g7',
    senderName: 'dn1xtouw3',
    senderSignature: 'xbhexjea8',
    recipientName: '2ertwciw2',
    recipientSignature: 'qknndrzg8',
    aiSummary: '2ryrkx2q2',
    submittedAt: 'ybkpqzwq5',
    acknowledgedAt: '0kcxnytg4',
  },
  actionItems: {
    eventId: 'nl7sv6jw7',
    handoffNoteId: 'wbf9fc5w4',
    title: 'yswhxlkg3',
    description: 'ytrt2fpg6',
    status: 'dj3zjbtq1',
    priority: 'ri0pfoyg4',
    assignedToName: '2assceaa2',
    deadline: 'jciyqspw4',
    creatorName: 'wcijjopg2',
    completedByName: 'gg2vupng2',
    completedAt: 'dtgxz5dq2',
  },
  personnel: {
    firstName: 'klpwnrsg6',
    lastName: '4mxy8q6a6',
    agency: 'yfhn7wgg2',
    position: '7kdfnhgg3',
    pin: 'k9t8xqqg2',
    badgeId: 'uphexcbw8',
    phone: 'hmi6yinq1',
    email: 'znfeoleg8',
    notes: 'fo4j6ova1',
    status: 'zii5ekqq5',
    creator: 'w8ufzv0w6',
  },
  rcEvents: {
    incidentId: 'jvbsogmq1',
    eventType: 'emtv0obw4',
    mealType: 'jcvc48ka4',
    name: 'sjfohdjq5',
    eventDate: 'borzbbpw1',
    startTime: 'qm5xuwzq3',
    endTime: 'g5u5ihja8',
    location: 'ny2a2dmq5',
    notes: '12rv457g4',
    eventStatus: 'txkoqnig3',
    autoCheckoutHours: 'rpqjlueq5',
    creator: 'fe6ievua5',
  },
  perimeterIncidents: {
    title: 'sqrqi89a1',
    status: 'uub4ulta2',
    address: 'phm7xuya3',
    centerLat: 'o62h1u5q5',
    centerLng: 'yq8o5vbw8',
    radius: 'qdv5237g3',
    shape: '5qtrx4iq5',
    density: '2i2umzua2',
    cameraCount: 'xmhdtbzq4',
    popLow: '0rxmfroq3',
    popHigh: 'nggjvj3g1',
    popArea: 'bum7oufg1',
    createdBy: 'k1kbrypw2',
  },
  perimeterPoints: {
    name: '4xtph4xw4',
    incident: 'hz5z2b0w4',
    externalId: '6rszmidg7',
    lat: 't2k8bypg4',
    lng: 'slu4qczg4',
    category: 'jbcauazg1',
    categoryLabel: 'wly64i5q6',
    categoryIcon: '2dt7teeg2',
    address: 'umnaax6q7',
    phone: 'z0mt98qq2',
    distance: 'ug48pbvg6',
    source: '0won7lug7',
  },
  perimeterClosures: {
    incident: 'vuvi95yq5',
    name: 'vqaf6y9q6',
    lat: 'gjpff5zq4',
    lng: 'ypfg6otg7',
    distance: 'r7u06x7g6',
    direction: 'jzpqviba6',
    roadType: '5ysi0fgg5',
    priority: '5imtiflq8',
    streets: 'pc5ndsoq1',
    bearing: 'nyst4gka3',
  },
  perimeterBriefings: {
    incident: 'b8vuthfw8',
    content: 'rvrerimq1',
    generatedBy: 'i48m9m9g2',
    radius: 'kqokwdqa7',
    shape: 'xdzxm8dw8',
    density: '4krqyt4w4',
    poiCount: 'kpw0ve4q2',
    closureCount: 'zqgvxjzw1',
    cameraCount: 'rjyincew2',
  },
  geoopsZones: {
    name: 'plyjqqxq8',
    incidentId: 'q6bl3m5q6',
    zoneType: 'nzsdyglg4',
    geometry: '10ddkzpw2',
    status: 'hcelz9za6',
    color: 'zvl41ojg4',
    opacity: 'npz2yszg5',
    notes: 'kjapf6aa6',
    createdBy: '6hzem6pg6',
    lastUpdated: 'afqqo1uw7',
    sortOrder: 'um1d89ma1',
    metadata: '7pmnxl5g2',
  },
  rcCheckins: {
    eventId: '1zxnuhrg2',
    personnelId: 'f5jzespq1',
    personnelName: 'fozci6xg6',
    agency: 'mdemcmfg8',
    position: 'wq8saoug3',
    checkInTime: 'arzf2g2g2',
    checkOutTime: 'pgzhmufw1',
    method: 'qx3pnjbw7',
    geoLat: 'bxhwr91a2',
    geoLng: '6knz4zdg4',
    geoAccuracy: 'fnpwd2rw6',
    checkedOutBy: '9uinpmaa5',
  },

  // Impact — Assessments
  impactAssessments: {
    address: 'vymcmjew1',
    assessmentType: 'v69bfqzg4',
    county: 'egcbdfsg8',
    damageCategory: 'm86qcmag1',
    fipsCode: 'wy1w4fdw1',
    incidentId: '65oybjiw1',
    latitude: 'hkjjpoew1',
    longitude: '39dadqlg1',
    paCategory: 'ceat8fha5',
    severity: '745uysvg4',
    stateCode: 'vsrri8aa4',
  },
  impactDetails: {
    assessmentId: '2idmhgbg2',
    damageTypes: 'pwfvtrqa5',
    description: 'uvnklw2w5',
    dwellingType: 'axi9rebw6',
    habitable: '0n4sxghg6',
    insured: '7zaupwkq4',
    occupants: '3fxf7y1w8',
    ownership: '44rwuyxg8',
    residenceType: 'laqvfqzw7',
    waterLineHeight: 'oco0e2na2',
  },
  impactExtras: {
    assessmentId: 'smk7jfxg7',
    assessorEmail: 'dim7msjq8',
    assessorName: 'aewt2owg8',
    bulkEntry: '1lazgovw6',
    facilityName: '83fjlu8g8',
    facilityType: 'pmvbssrg3',
    homeCount: 'cq8cagsq6',
    method: 'sdnyo3yw8',
    neighborhood: '3kcicuww3',
    repairCost: 'wce6xjyg6',
  },
  impactPhotos: {
    assessmentId: 'zcytzaog7',
    caption: 'mkb1kfuq8',
    exifDate: '0jeovcww7',
    exifLat: 'wabmjp9g4',
    exifLng: 'ehbvs72g8',
    photoOrder: 'e9jkuqgw1',
    photoUrl: 'wujfxxca5',
  },
  impactSelfReports: {
    address: 'g5bv4caq8',
    city: 'c3ts2muq6',
    dwellingType: 'ripuaf2q1',
    incidentId: 'hyxytr2q8',
    occupants: '2r42stjw1',
    reporterEmail: 'kuzik9wa6',
    reporterName: 'o7hbqdjg1',
    reporterPhone: 'ejdshh0w6',
    stateCode: '91dgixka1',
    zip: 'dous0llg8',
  },
  impactSelfReportAnswers: {
    consent: '8bqa18rg1',
    damageCategory: 'g8gjexna4',
    damageScore: 'lyvi9kxa6',
    floodInsurance: 'sedi3nsa7',
    insured: 'x6k42fjq7',
    livingSituation: '4nfchzkw1',
    notes: 'k7peljfw7',
    reportId: 'h2l4b2uw4',
    reviewStatus: '1vxcfhpa7',
  },

  // Intake — Individuals
  individuals: {
    incidentId:   'u72mz5sw3',
    tagCode:      '1r8i5ptw7',
    firstName:    'h3wd9r9q2',
    lastName:     'kzkxbmng5',
    dob:          'bqy2hfdw1',
    gender:       'd41zvfuq7',
    triage:       'ehcswktg4',
    status:       'qzn3h7xq6',
    intakeMethod: 'vp5xkhlq2',
    checkedInAt:  'e6egg85a6',
  },
  individualDetails: {
    individualId:    'gvj2rkbq6',
    medicalNeeds:    '1gftuz2g3',
    medications:     'uiehcuia6',
    emergencyContact:'qpuouggq3',
    contactPhone:    'vgewe2fw4',
    guardianId:      'k1xc36tw2',
    photoUrl:        'nesyl8fq1',
    notes:           'bnjb6zea1',
  },
  triageHistory: {
    individualId: '9cthr9qg4',
    incidentId:   '3yobt31g1',
    triageLevel:  'isdrtn3a2',
    changedBy:    'hhshuowa8',
    reason:       'iyo9gxsw1',
    timestamp:    'nskuq7na4',
  },
  discharges: {
    individualId: 'ssmk1hjq6',
    incidentId:   'lpenazxq4',
    destination:  'il7cairq7',
    destDetails:  'rccr03eg3',
    condition:    '74ke57va7',
    dischargedBy: 'rc29bo1a3',
    dischargedAt: 'ta8gxvja7',
    notes:        '1lnffkya7',
  },
  propertyItems: {
    individualId:    'yabvgvnw4',
    incidentId:      'vxlmxmsa7',
    description:     'nk2jt2mq2',
    quantity:        'qszbsikg3',
    storageLocation: 'f5hbk54w2',
    status:          'xtn2lxwa5',
    receivedBy:      'su4s44vq4',
    receivedAt:      '9felmnpw6',
  },

  // PACE — Profiles
  paceProfiles: {
    backupValue: 'ppm8p1xw8',
    contactValue: 'blxkzouw3',
    department: 'klfpfhcg3',
    functionTitle: 'u05jznrw4',
    lastVerified: '50ctujpq2',
    method: 'majtylig2',
    notes: '5avqotra7',
    personEmail: 'rmn7ezjg4',
    personName: 'lhqqnw7g6',
    personId: 'nr3t6ujg6',
    tier: '3hoxplxw7',
  },
  // PACE — Call-Downs
  callDowns: {
    callStatus: '98i8cplw1',
    completedAt: 'hont96eg2',
    incidentId: '8vzrk8kg8',
    initiatedBy: 'w8cilkia8',
    memberCount: 'sdmz6klw2',
    respondedCount: 'n1kfdisg4',
    scenario: '8tkfffta8',
    scope: 'x27grlcq2',
    scopeId: 'igh57tdg7',
    script: '1m2tzmlq2',
    cdId: 'cafsuqyq7',
  },
  // PACE — Call-Down Responses
  callDownResponses: {
    callDownId: '25nwn5fq5',
    contactedAt: 'rskgqeya2',
    methodUsed: 'yefqswcq1',
    notes: 're9lmtha3',
    personEmail: '1ppuvflw5',
    personName: 'roqskm4a6',
    responseId: 'ha6iuucq6',
    responseStatus: 'ap2hdatw4',
  },
  // PACE — Call-Down Templates
  callDownTemplates: {
    creator: 'qcw5yona5',
    scenario: 'aubteezg4',
    scope: 'gkjwxjpa7',
    script: '6gojpxjw2',
    templateName: 'hujyb1wa1',
    templateId: 'jaukb7dq5',
  },
  // PACE — Plans
  pacePlans: {
    acknowledgedBy: 'k6xjr5yg3',
    creator: 'plne1lwg4',
    description: 'drbm1ziq4',
    planName: 'dsom6pjw6',
    planId: 'z94uux3g3',
    sharedWith: 'yyy5jmig5',
    version: 'etaalzha1',
  },
  // PACE — Plan Entries
  pacePlanEntries: {
    contactValue: 'lo2oeu2q2',
    method: 'cj2fjeig3',
    notes: 'ljcs5mpq6',
    planId: 'peauj3ow6',
    entryId: 'wneqachq8',
    sortOrder: '7oyozumg7',
    tier: 'ciaahbdw1',
  },

  // VolunteerOS — Volunteers
  volunteers: {
    firstName: 'zeeip3qg1',
    lastName: 'ho77se8g7',
    email: 'drfiueeg6',
    phone: 'zyppt9jg7',
    org: 'tgm555zg5',
    rolePref: 'xsppmsag1',
    certs: 'xnl2vjcg1',
    skills: 'afql6ipw4',
    status: 'lfl9loha2',
    availability: 'ntkitfeq1',
    ecName: '9wgdnbiw8',
    ecPhone: 'd4zxjrcq6',
    notes: 'p1wdmjsa1',
    registeredAt: 't2thgf6g1',
  },
  // VolunteerOS — Events
  volEvents: {
    incidentId: 'bvdrbyew2',
    name: '2ai1do7q2',
    type: 'vp68pbpq4',
    status: 'jzgkivmq4',
    location: 'epdc2qww3',
    address: 'e5ltet7w4',
    startDate: 'zqncfseg8',
    endDate: 'myd3fupa4',
    targetVol: 'qjlei07a7',
    reqCerts: 'wpuphf2g3',
    checkInCode: '3kqd5btw2',
    notes: 'xl8cjwmg7',
  },
  // VolunteerOS — Assignments
  volAssignments: {
    volunteerId: 'wqgjmlqq5',
    eventId: 'fzr927qq2',
    incidentId: 'kankoawq8',
    role: 'mftitjda8',
    status: 'amnm3lha2',
    shiftDate: 'i9zchcng1',
    startTime: 'f4eepxng4',
    endTime: 'mkbxcbug5',
    checkIn: 'jj24yifg4',
    checkOut: 'yqknhciq1',
    hours: 'l8gq480w8',
    notes: 'zsmdq9dw1',
  },

  // Blackboard — Roster (shared users table)
  roster: {
    email: 'vjvphw7g7',
    firstName: 'qcmzisfa8',
    lastName: 'ysnqb8ca8',
    role: '3c0qvfca6',
    active: 'ksev2ipw7',
    position: 'spjbm1eq2',
    orgName: 'pjg7ztfa7',
  },
  // Blackboard — Trainings
  trainings: {
    name: 'fk644dqa7',
    category: '8xumni3w3',
    description: 'p4hmj8kg8',
    frequencyDays: 'gv46g8uq6',
    requiredForRoles: 'arjohpbq7',
    active: 'ozfcgp4w6',
  },
  // Blackboard — Training Records
  trainingRecords: {
    userId: '59wvmdzq5',
    trainingId: 'wxmqkw0a1',
    trainingName: 'micql7rq3',
    userName: 'gg2ohkma3',
    completedDate: '8njrxnpw1',
    expiresDate: 'lo4wovha8',
    status: 'qkv5skzw5',
    notes: 'ldlsal4g2',
    certificateId: '6f7jj7bq7',
  },
  // Blackboard — Classrooms
  classrooms: {
    title: 'ub5y5kxq5',
    trainingId: 'enp4rjqa4',
    instructorId: 'fvamavmq6',
    instructorName: 'blta84pg8',
    classDate: 'ydrtgrrq6',
    classTime: 'qipry6qw4',
    location: 'vups8odw2',
    capacity: 'nbe91dgg7',
    status: 'jbr4qeha4',
    registeredUsers: 'pneh3rwa4',
    waitlist: 'naotuizw4',
    attendance: 'nkdxhhgg2',
    creatorId: '2kvhlleq5',
  },
  // Blackboard — Certificates
  certificates: {
    userId: 'ummeodtw3',
    userName: 'h1zb46cg1',
    trainingName: 'zdeqxp3g1',
    trainingId: 'wqsbagwa7',
    certCode: 'qhdt38ra8',
    completedDate: 'h20ocaya6',
    expiresDate: 'ewnjicqg2',
  },
  // Blackboard — Position Plans
  positionPlans: {
    position: 'qeu7tfkw8',
    trainingIds: 'yk9aqtpw3',
    trainingNames: 'haliry0q7',
  },
  // Blackboard — Assignments
  assignments: {
    userId: 'ffgnancw4',
    trainingIds: 'mxu96wkq8',
    dueDate: 'kh263xsw7',
    notes: 'dbbd7ejw5',
  },

  // Battle Rhythm
  brMeta: {
    incidentId: 'z566s6iw8',
    opHours: 'n8efc5xq8',
    opStart: 'fmyt5nlw1',
    org: 'w4lr8m2q5',
    templateId: 'fc5jwpma1',
    status: '2zpx2dpq2',
    closedAt: 'vb8vnvow8',
    creator: 'tupvaidq2',
  },
  brEvents: {
    incidentId: '6dkmajyw5',
    title: 'u96wez9a1',
    category: 'yynlym2w1',
    scheduledTime: 'dpwifq8a2',
    durationMinutes: 'tezuba1g1',
    location: 'ugahcmgq1',
    responsible: 'ywayfsbw2',
    notes: 'kiji1eeq1',
    recurring: 'it8bpf4q7',
    adHoc: 'rf0pvvpg4',
    status: 'yh55tzzq5',
    completedBy: 'dzlmppgw7',
    creator: 'himzqtyq3',
  },
  brTemplates: {
    name: 'lniac13g1',
    description: 'hyolswbq2',
    opHours: '9i9z56ug7',
    events: 'imn3tn1q1',
    creator: '94reukqq8',
  },

  // MainStreet — Organizations
  msOrganizations: {
    name: '4spr8cyw8',
    sectorType: 'yp7xd4fq4',
    address: 'zhyxpkpa2',
    city: 'gzrfxdya8',
    state: 'fdc2um8g1',
    zip: 'ptsxufqw8',
    phone: 'ss08qebw7',
    email: 'ewdrmang4',
    primaryContact: 'zj1qpqvg4',
    opStatus: '4qqlcsng3',
    insurance: 'xhpismsg2',
    continuity: '1pghuyda6',
    lastVerified: 'pruxohva7',
    notes: 'qwfbcknw8',
    coordinates: 'hp98wqpa6',
  },
  // MainStreet — Status Checks
  msStatusChecks: {
    incidentId: 'tuqoal1q5',
    title: 'fvz7djbg6',
    question: 'direbgag2',
    targetType: 'wuswj4qw2',
    targetSectors: '3hkikmbq2',
    targetOrgs: 'tmi4fkaq8',
    deadline: '2rfwujng8',
    status: 'v09xdang5',
    createdAt: 'xtzqz8ig3',
    authorName: 'mcpsbekq2',
  },
  // MainStreet — Status Responses
  msStatusResponses: {
    statusCheckId: 'uzhzvnma2',
    orgId: 'l4uvge8g1',
    orgName: 'pssaurtw4',
    response: 'vbqn0yxa6',
    notes: 'zqsbyw8a3',
    respondedAt: 'n4ssonua4',
  },
  // MainStreet — Damage Reports
  msDamageReports: {
    orgId: 'rrxrympw4',
    orgName: 'rruckb1g8',
    incidentId: 'hnyxuqfa6',
    opStatus: 'ykfnhugw5',
    damageTypes: '3pis9qng3',
    description: 'bhfeco3g7',
    severity: '2cohyejw8',
    reportedBy: 'vvyz9geg1',
    reportedAt: 'gdgjdt4a3',
    photos: 'uv23fl0q1',
  },
  // MainStreet — Resource Offers
  msResourceOffers: {
    orgId: 'pgrclrqq1',
    orgName: 'pprssmbw8',
    incidentId: 'jjyudtvg7',
    offerType: 'jzjloqeg1',
    description: 'd4wllw1a6',
    quantity: '2pwxirhw8',
    status: 'u0457rcg4',
    offeredBy: 't3szxbqw4',
    createdAt: 'spvaucga7',
    notes: 'c5tgcpkq5',
  },
  // MainStreet — Posts
  msPosts: {
    incidentId: '5iga882a3',
    content: 'hdvnzgiw7',
    postType: 'uezyarkq5',
    priority: 'oekwdraa1',
    authorName: 'j2maldhq2',
    createdAt: 'jd2sl42w1',
    targetType: 'gddplysg5',
    targetOrgIds: 'lqrtqrzq4',
    targetListId: 'nax34wwa2',
    parentPostId: 'fnukcwkw6',
    readBy: 'rd3g9mxq2',
  },
  // MainStreet — Facilities
  msFacilities: {
    orgId: 'jxnaqx8w5',
    name: 'y19zidhg5',
    type: '21jvpjsw1',
    address: '03rpruaw7',
    city: 'zls3hkyg7',
    state: 'e4d5pchw4',
    zip: 'lahg5o9w5',
    buildingType: 'ijortdgq5',
    sqft: 'vtv5lquw4',
    stories: 'otneelkg4',
    occDay: 'oiy5zfbw5',
    occNight: 'fcdj3hlq7',
    hasGen: 'lvxmtf5g5',
    genDetails: 'd9ybtn5w4',
    hasHazmat: '4wmdhg4a3',
    hazmatDetails: 'gax4pa9w4',
    notes: 'q7wnk2bq8',
    coordinates: 'cfq1recq3',
  },
  // MainStreet — Contacts
  msContacts: {
    orgId: 'nadz2h6w2',
    name: 'gf2lrptw3',
    title: 'xhn2dl5w5',
    dept: '6w7xovlw2',
    type: 'sffsmjzq1',
    email: 'nh7nvh1g2',
    phone: 'il0a2sta6',
    altPhone: 'gezn91tg7',
    canAuth: 'q9nlspza6',
    notes: 'm5vxrqyw8',
  },
  // MainStreet — Org Lists
  msOrgLists: {
    name: 'g8dlr5ja5',
    desc: 'pv2531ra1',
    orgIds: '0c2yavqg1',
    createdAt: 'hlj93x7g3',
  },
  // MainStreet — Reentry Authorizations
  msReentryAuths: {
    incidentId: 'nkgtqrsw6',
    title: 'fniv5mua5',
    targetType: 'sbzt5bqw3',
    targetSectors: 'o4bgzxbw3',
    targetOrgs: 'h1xsowew3',
    issuedBy: 'et8xbx4a8',
    issuedAt: '9wddxfva1',
    expiresAt: 'jmng5oaq5',
    status: 'zv9flffq5',
    notes: 'xfpzgflw3',
  },
  // MainStreet — Reentry Passes
  msReentryPasses: {
    authId: '8uenjsrq4',
    orgId: 'n90cmdpg3',
    orgName: 'hvdhl69g3',
    code: 'eqvswflg7',
    status: 'oolf8dcw5',
    issuedAt: 'avf1n28q3',
    expiresAt: '9q2rsyxw5',
    verifiedAt: 'juaxjvdw2',
  },
  // RBAC — Roles
  roles: {
    roleName: '6aiditwg3',
    roleSlug: '2xvpxzsw7',
    description: 'yekug7mg6',
    permissions: 'khzlj8nw8',
    isDefault: 'v65nyyaw1',
    sortOrder: 'td8sxv1g6',
  },
  // RBAC — User Roles
  userRoles: {
    userEmail: 'ewav6hdq6',
    userName: '2m25xjbq2',
    roleId: 'xmjikjqq6',
    roleName: '514zsbsg7',
    assignedBy: 'w2fcksgg2',
  },
  // File Library — Documents
  documents: {
    title: '86jhae9w4',
    description: 'tb4iieqq1',
    category: 'tl2pevaq2',
    tags: 'scgr4kwg1',
    fileUrl: 'kh0ygnmg7',
    fileType: 'c2fsojoq2',
    publishDate: 'wdcqtgxa7',
    expirationDate: 'tkrbg90w3',
    status: '4ikgoy4a3',
    uploadedBy: 'pwx6juva8',
    version: 'h5vdlqlq4',
    priority: 'ncyyjx8g8',
    fileUpload: 'tyrww7xq8',
  },
  // File Library — Categories
  flCategories: {
    name: 'td6royqw6',
    icon: 'worcvdpa5',
    color: '7in1totg1',
    sortOrder: 'kiccu3yq3',
    active: 'vzsiw8za5',
  },

  // ── Debris ADMS ───────────────────────────────────────────
  debrisZones: {
    incidentId:           'hepgox5g5',
    zoneName:             'aoma8meg6',
    zoneCode:             'bhtdmbpa3',
    status:               'wun8z3qw8',
    boundaryGeojson:      'z5if56vw5',
    centerLat:            'hnbr8q4g8',
    centerLng:            '4tn6qyyq8',
    estimatedCubicYards:  'dix8sqcw8',
    actualCubicYards:     'w2dkxddg2',
    debrisTypes:          'mgdcax1w8',
    assignedContractorId: 'ajmp0jdq7',
    notes:                'pujrn7vg5',
    creatorEmail:         't7xg6gvq7',
    currentPass:          'fo8wnvsq8',
    passHistory:          'h7fsayja8',
  },
  debrisContractors: {
    incidentId:           'melvgyda3',
    companyName:          '1dzsqmjq8',
    contractNumber:       'ru72bbmq1',
    contactName:          'ys590spq1',
    contactPhone:         'ssaog8bq7',
    contactEmail:         'xokkmmiq8',
    rateVegetative:       'vnrxl6gq2',
    rateCAndD:            'yaoovchw5',
    rateSoilMudSand:      'b71nvbaw7',
    rateHazardousTree:    '5no0smrg4',
    rateStumpRemoval:     'b9ro4efw5',
    rateWhiteGoods:       'ftsncv1q4',
    rateElectronic:       'r7rnjncg6',
    rateHhw:              'boxqirvq5',
    status:               'yu4hyn7q8',
    notes:                'xxj0rqkw8',
  },
  debrisCrews: {
    contractorId:         'ihssnb4a1',
    incidentId:           'edqd1tqa5',
    crewName:             'o8ome1za5',
    crewType:             'bhddpe0w3',
    truckId:              'bh0rs0hq1',
    driverName:           'x6qb841q6',
    driverPhone:          'sxkzyvaa5',
    driverEmail:          'ogg4xt7a2',
    status:               'z2cck3lg3',
    assignedZoneId:       'rfcp2ylw7',
    notes:                'yjk7s6gq3',
  },
  debrisTrucks: {
    contractorId:         'jh8bskpw5',
    incidentId:           'krxdr2ww8',
    truckNumber:          'kri1s8uq3',
    licensePlate:         'kkfh6uqw1',
    truckType:            'olhkhmvq5',
    lengthFt:             '7b61ardq1',
    widthFt:              'umksiw5w7',
    heightFt:             '1ycnzlxw3',
    cubicYardCapacity:    '9u6lv43g8',
    certifiedDate:        'ew99f1eq5',
    certifiedByName:      'eioabzsw8',
    certPhotoUrl:         '88frtgig6',
    qrCode:               'jajmbbtq4',
    status:               'm7pegxlq3',
    notes:                'vhrim3qg6',
    hasTailgate:          't6f827ow6',
    certExpiresAt:        'jtim8htg4',
    certStatus:           'o5qwduvw4',
    placardNumber:        '3qovd27a3',
    bedPhotoUrl:          'rycycadq4',
  },
  debrisLoadTickets: {
    incidentId:           'pmgdgufa8',
    ticketNumber:         'tzbvfglq7',
    truckId:              '87g4xgeg7',
    truckNumber:          'jkinxuzg7',
    crewId:               'aiaysvna2',
    contractorId:         'jntq5ehw1',
    zoneId:               '8i6ir08g8',
    disposalSiteId:       'brbcaoxw7',
    debrisType:           'iyymmf4q4',
    loadPercentage:       'j7hvkryw2',
    calculatedCubicYards: 'vkfn8cpg8',
    pickupLat:            '1t1p9ahw7',
    pickupLng:            'vwfamvgg5',
    pickupAddress:        'jlfjtv2a2',
    pickupTime:           'vk3mzt8q5',
    disposalTime:         'z5nxpdqa5',
    monitorName:          'g3vvgd3a2',
    monitorSignature:     'wv5pv81g1',
    driverSignature:      'heuqg5jw2',
    status:               'sotbrp0g4',
    photoBeforeUrl:       'fcp38deq3',
    photoAfterUrl:        '5aw8koja6',
    photoLoadUrl:         'eoidbqvw6',
    notes:                '4drbrxha1',
    pickupStopsJson:      'k73zheja6',
    measurementMode:      'rdy03dwa8',
    unitCount:            'b4qr4law4',
    unitSubcategory:      'qhfxqqka7',
    diameterRange:        'm4rt0cua5',
    weight:               'idqfl5rq5',
    weightUnit:           'moxzx4ww5',
    scaleTicketNumber:    'u9us59gw6',
    verifiedAt:           'lxw0w5iw1',
    qrCode:               '5yyhdebq5',
    loadingMonitorName:   '3p3qpzdq3',
    loadingMonitorSignature: 'r6axvnqw6',
    loadingLoadPct:       '6fo7pyiw4',
    towerLoadPct:         'xxovzx9g2',
    handLoaded:           'g41nvsqw8',
    driverPickupSignature: 'gby3ucfq8',
  },
  debrisDisposalSites: {
    incidentId:           'law6uaow3',
    siteName:             'xoym37hw3',
    siteType:             'jrjk3euw5',
    address:              '65i3pvbq3',
    latitude:             'hr2xeuyw1',
    longitude:            'xec6eiow6',
    capacityCubicYards:   'awq0lkma4',
    currentVolume:        'vsgctldq8',
    acceptedTypes:        'yfzyuevg7',
    operatingHours:       'j13ymtgq8',
    monitorName:          '2nynm2eg2',
    monitorEmail:         'hk0rgsbg5',
    status:               '8n9oifha7',
    notes:                'l8r1u9pg5',
  },
  debrisPhotos: {
    parentId:             'ezkgj73a4',
    parentType:           'ojkgu2iw3',
    incidentId:           'lzh04i5q2',
    photoUrl:             'zlb5mkeg2',
    caption:              '0orxggpa2',
    geoLat:               'ttzqyt2q4',
    geoLng:               'ccrrdqcg5',
    takenAt:              'uubi1koq2',
    uploadedBy:           'ss4b7aaa5',
  },
  debrisAuditLog: {
    incidentId:           '8xwofhig5',
    entityType:           '3qj04shg3',
    entityId:             'mnyekjwa2',
    action:               'm7u8idwq7',
    fieldChanged:         '8tcdpxnq8',
    oldValue:             'uybmlm7q4',
    newValue:             'kvs6i3iw3',
    actorName:            'rzkkm1uq1',
    actorEmail:           'kjicei1a4',
    actorRole:            '47otaazw4',
  },
  debrisMonitors: {
    incidentId:           '0btuwaew5',
    fullName:             'zjspaouw8',
    company:              'coigp8fq5',
    email:                'xmjr4vug4',
    phone:                'r3l3hd1g3',
    role:                 'yntxip7w6',
    assignedSites:        'itpseyca7',
    assignedZones:        '1ebjwwng6',
    certifications:       '8dtp3pwa6',
    status:               's4asjgnw7',
    notes:                'rzq0fjwa7',
  },
  debrisRateSchedules: {
    incidentId:           'pcrqpbwg4',
    contractorId:         'lkegt4ow5',
    lineItemCode:         '7c7hkuca3',
    description:          '0ori2h6w7',
    unit:                 'rir6au7g8',
    baseRate:             'zouvdieq8',
    tier2Rate:            'jjvpfb5w1',
    tier3Rate:            'v2x428sq2',
    tier4Rate:            'jvzfzvcq3',
    notes:                'urqbznya4',
  },
  debrisRightOfEntry: {
    incidentId:           'svehjc0g5',
    propertyAddress:      'ndgyle7q7',
    latitude:             'ls5a5siw6',
    longitude:            'qvt5rjxq5',
    ownerName:            '1dyh9uoq4',
    ownerPhone:           'hohgeqpq7',
    ownerEmail:           'wjflfetg7',
    ownerSignature:       '2cbwkhfq4',
    signedDate:           '45pxkm5q2',
    status:               '5xq82ybq2',
    zoneId:               'o5jjlrag5',
    debrisTypes:          '3cct6vmg8',
    clearedDate:          'mqkicqza1',
    clearedBy:            'nvzncksq1',
    beforePhotos:         'bk8bzbvq8',
    afterPhotos:          'bgkecxpg7',
    notes:                'davdl5uq2',
  },
  paMitigationProposals: {
    projectId:                'lvjr17eq1',
    organizationId:           'rrfx0aqg5',
    disasterId:               'piy1cajw4',
    proposalTitle:            'bnbjicqa5',
    measureType:              'smk8rmgq7',
    description:              'hzdczhmg5',
    engineeringJustification: 'q7actw6g6',
    mitigationCost:           'tgvqlsxg6',
    costPercentage:           'zraf9epw4',
    bcaPath:                  'noa8alva8',
    bcaRatio:                 'bm5qdjjq4',
    pvBenefits:               '4ilnpssg4',
    pvCosts:                  'maqdpm1q1',
    usefulLifeYears:          'vekqw8vg8',
    discountRate:             'rswls7iq7',
    bcaReportUrl:             'tz44ydeq3',
    costEffectivenessNarrative: '0i2dt71a4',
    status:                   '9drsuwdq3',
    submittedBy:              'pnuouetq7',
    submittedDate:            'sekkkjaw1',
    reviewedBy:               's79awiha4',
    reviewDate:               'p5okx3lg1',
    reviewNotes:              'segcxmrw2',
    hazardType:               'yofw1kja1',
    notes:                    '9ujkodaq5',
  },
  debrisDocuments: {
    incidentId:           'bohoxloq1',
    title:                'cumuordq7',
    category:             'nkafz5ba8',
    description:          'onapeoya3',
    fileUrl:              'mo7kzgsg5',
    uploadedBy:           'okzo4w6g7',
    visibleTo:            'ukazoxwg7',
    status:               'yhcfkb4q6',
  },
  debrisInvoices: {
    incidentId:           'st0gdghq5',
    contractorId:         '6mzwqomw7',
    invoiceNumber:        'yidyivvg5',
    periodStart:          'qfdaq4iw3',
    periodEnd:            'wjkzet0q4',
    totalCubicYards:      'k2st8mtq8',
    totalAmount:          '4mapovzq5',
    ticketIds:            'wztqbg4g6',
    lineItems:            'fg5cepgq4',
    status:               'elh03hhq5',
    approvedBy:           '5uqe8pyg8',
    notes:                'nxekgraa3',
  },

  // ── Shelter Management ───────────────────────────────────
  shelters: {
    incidentId: 'qjha38ng2',
    name: 'uxnyc36g2',
    address: '1cfz5tna4',
    latitude: 's5p1kgfw4',
    longitude: 'hlhofeea4',
    capacity: '3iqwtcog3',
    currentPopulation: 'q3os9w1w1',
    isAda: 'wsgsn6ea1',
    petFriendly: 'eeum0pga3',
    status: '3a0n0vmg3',
    shelterType: 'x7vjbuwq6',
    facilities: 'r0iotqlw2',
    contactName: '3vplz2eg3',
    contactPhone: 'bzo32n4g2',
    contactEmail: '2no44jyg2',
    operatingOrg: 'ltopjhsg4',
    openedAt: 'bewicrfq1',
    closedAt: 'zsxrkr9q7',
    notes: 'hruck91w8',
  },
  survivors: {
    incidentId: 'tjvzc4gw1',
    shelterId: 'rqmgtg4q5',
    familyId: 'zmncrkwq4',
    firstName: 'anexysrg6',
    lastName: 'ryiuijda7',
    dateOfBirth: 'a6fpllfg6',
    gender: 'yqf1tq9w6',
    phone: 'hpndunpw7',
    email: 'pqngudgg4',
    homeAddress: 'y5berc2q3',
    city: 'tjl7skha5',
    state: 'a7gd1odq3',
    zip: '2lzxbpma4',
    county: '86ciqhmq8',
    photoUrl: '6xassoqw2',
    qrCode: 'teirqfiq6',
    status: 'lchqzubw4',
    isMinor: 'itehamlg3',
    isUnaccompaniedMinor: 'nl4oxalg6',
    guardianId: '6jw3xltw6',
    cotAssignment: 'fs95yeeg4',
    specialNeeds: '1mk6aqiq6',
    dietaryNeeds: 'kglxlkla2',
    medications: 'zc1ogxfg2',
    emergencyContactName: 'ce8e5skg3',
    emergencyContactPhone: 'gplytlkg1',
    intakeTimestamp: 'hwatpjjq2',
    dischargeTimestamp: 'wjr2equq3',
    dischargeReason: '6juppq3a3',
    dischargedBy: 'spatz6yw6',
    intakeBy: 'luq2rlew2',
    notes: 'fid51zyg5',
  },
  shelterFamilies: {
    incidentId: 'apngwosw1',
    familyName: 'kf0g9xoa1',
    headOfHouseholdId: 'yra8lctw7',
    memberIds: 'ycw0yoog5',
    memberCount: 'dlwmp46g6',
    notes: 'bsl7jh4a6',
  },
  shelterPets: {
    incidentId: 'm4odj0wg8',
    shelterId: '9gxemt5a6',
    ownerId: 'lae4ixpq8',
    name: 'qfr5kbua4',
    species: 'brzfyizw3',
    breed: 'qafius6g1',
    color: 'wnhik0jw3',
    weight: 'txfcqzrw1',
    qrCode: 'bxy4c5eg3',
    status: '0bu48odq1',
    medicalNeeds: '8vluglhg8',
    locationInShelter: '0xsdweyq5',
    photoUrl: '2ec437rg4',
    notes: 'nqonz7qw8',
  },
  shelterVehicles: {
    incidentId: 'hukdhrgg5',
    shelterId: 'jshjjyya3',
    ownerId: '2ddswm9q2',
    make: 'ft3h9jxq3',
    model: 'm54ijkga1',
    year: 'jz5jfglg3',
    color: 'zezcfjfg7',
    licensePlate: 'hc6cohqq8',
    state: 'lvdo7w5a2',
    vin: 'igavu4jq4',
    qrCode: '2fdfnacq6',
    parkingLocation: 'd2mf0icg1',
    status: '7i4goysw2',
    photoUrl: 'qvze1caw1',
    notes: '26mtuncw6',
  },
  triageQuestions: {
    incidentId: '9v6fq4kq7',
    question: 'e2vol8aw8',
    questionType: 'ruugyxng7',
    options: '8x61vr9a1',
    category: 'fbyvrw1g4',
    sortOrder: 'g3bsuxtq2',
    isActive: 'zok1aayg4',
    flagIfAnswer: 'vchwpwzg7',
  },
  triageAnswers: {
    survivorId: 'bhl4lnog4',
    questionId: 'envbpbvg3',
    answer: 'hkcmclaw4',
    isFlagged: '9p9slclw8',
    answeredAt: 'ofcoo76g6',
    answeredBy: 'y4c1mxlq1',
  },
  medicalLog: {
    incidentId: 'p0lj38fw2',
    survivorId: 'zq6c8skw6',
    shelterId: 'tinldbyg3',
    entryType: 'fxmkp42q6',
    description: 'gkifh8rq3',
    medicationName: 'ttn296zw2',
    dosage: '8dhrwckg2',
    administeredBy: 'ptzch2xa2',
    timestamp: 't7a0uwyg8',
    followUpNeeded: 'f1zuduxa2',
    followUpDate: 'utlvwxkg4',
    notes: 'ziujwbkg2',
  },
  shelterTransfers: {
    incidentId: 'gv5r5xcq5',
    survivorId: '4azorj2w4',
    survivorName: '1qcqrlta6',
    fromShelterId: '8wf8mjbq2',
    fromShelterName: 'q4d98ekq6',
    toShelterId: 'bf6nuxyg3',
    toShelterName: 'i1sirttg7',
    reason: 'edlxpfxq4',
    status: 'xzo7x97g7',
    initiatedBy: 'aqt7zc4a3',
    initiatedAt: 'fe9jxu4q5',
    completedAt: 'u8nsxluw1',
    notes: 'lvuy00va1',
  },
  shelterProperty: {
    incidentId: 'vjazih0g7',
    shelterId: 'rkln7naa5',
    ownerId: '0bruz8aq7',
    description: 'amh7ek8g8',
    category: 'etsbnypw8',
    storageLocation: 'sbzxjg9w6',
    qrCode: 'w1hriqzw1',
    checkedInAt: 'nxlmd1sq2',
    checkedOutAt: 'f3jjetog3',
    checkedInBy: 'jtiol3ww6',
    photoUrl: 'nuf5ieaw2',
    notes: '5ii7p48q8',
  },
  shelterIncidents: {
    incidentId: 's5sacqdq5',
    shelterId: 'stqbxwgw6',
    reportType: 'citjyv1w6',
    severity: 'kdws8kfg6',
    description: 'l55x4j7a7',
    involvedPartyIds: 'hcqvdkma2',
    respondingStaff: 'wu76dtng3',
    resolution: 'hv808oxg8',
    followUpNeeded: 'd4viipza8',
    reportedAt: 'gmcjemua2',
    reportedBy: 'jynce18g8',
    resolvedAt: 'dgpuskta1',
    notes: '7afhfh6g7',
  },
  shelterReferrals: {
    incidentId: 'bvx5zooa3',
    survivorId: 'lyxiaa5q8',
    survivorName: 'azhssupw3',
    referralType: 'amg1rgaa4',
    agency: 'wkkiti0w8',
    caseNumber: 'w4nsv74g4',
    status: 'fxg4ublq2',
    dateMade: 'csmrqeug4',
    completedDate: 'zp9sneng1',
    madeBy: 'brmw5xlg5',
    notes: '1mf1u2mq5',
  },
  shelterSupplies: {
    incidentId: 'huurhfww6',
    shelterId: 'o04ypnma4',
    itemName: 'kl3mfs7a2',
    category: 'gtm67cxw3',
    quantity: 'afo12e2g3',
    unit: 'ksvkdh2w7',
    reorderThreshold: 'c83kvifg8',
    lastRestocked: 'tnvzp7gg1',
    notes: 'zauqoaaa8',
  },
  reunification: {
    incidentId: 'eatpwjaw2',
    requestedByName: 'cdjxvbpq2',
    requestedByPhone: 'skwfuoag6',
    requestedByEmail: 'zhyazkda6',
    missingPersonName: 'bbpa9vea2',
    missingPersonDescription: 's4a5z9bq4',
    lastKnownLocation: 'flosgw2q2',
    lastKnownDate: 'yqqjsrta4',
    relationship: '1hmdd4mg1',
    matchedSurvivorId: '24ray3hg1',
    status: 'xgxhep9a7',
    photoUrl: 'hqhshrua5',
    createdAt: 'bkqdffpa2',
    resolvedAt: 'o4pazltq7',
    notes: 'i8b05xug7',
  },

  debrisRequests: {
    incidentId:          'kymtvqdw6',
    assessmentId:        'gyg4ejgw8',
    address:             'w4inziha4',
    latitude:            '2a1ud2tg2',
    longitude:           'hjyvpc6q2',
    damageCategory:      'h2q3lhma2',
    damageTypes:         'pmwyyduw6',
    description:         'm3mkkl0g5',
    status:              'sud9j6ea3',
    taggedBy:            'zutzdz5g5',
    taggedAt:            'dc6psa6q6',
    actionedBy:          'uyajvs0g1',
    actionedAt:          'nkgvqvaa1',
    createdTicketId:     '29391vya4',
    notes:               'a8u7xjsa5',
  },

  // ── PA Grants ───────────────────────────────────────────────
  paOrganizations: {
    orgName: 'ky08faka8',
    orgType: 'lb13mffw3',
    orgRole: '9kz9fwhq8',
    parentOrgId: 'yzfjuyfg7',
    fipsCode: 'iugiuyaa4',
    femaApplicantId: 'n39l3mja3',
    ueiNumber: 'ksvnuwog6',
    samRegistered: 'xdul6fyq4',
    samExpirationDate: '4l54y0wa4',
    einTaxId: 's2g4igqw4',
    congressionalDistrict: '7udlhsfa2',
    physicalAddress: 'nb6a8e5w5',
    physicalCity: '8shnrzlq8',
    physicalState: 'rreir1cw6',
    physicalZip: 'qddn1xvw3',
    physicalCounty: 'qvvcoyvq4',
    mailingAddress: 'j6ve8xmw4',
    mailingCity: 'sclukzdw8',
    mailingState: 'wq6lomnq1',
    mailingZip: '6zjiq6ua4',
    primaryContact: 'xl0ll53q7',
    primaryTitle: 'sqkkw9pa2',
    primaryEmail: 'w5mr5d1w5',
    primaryPhone: 'owqaj6ka4',
    altContact: 'oecdwcgq4',
    altTitle: 'schasmra5',
    altEmail: '43ijddrw4',
    altPhone: '8jub80uq8',
    garName: '7yya3saa6',
    garEmail: 'bs2b157a8',
    garPhone: 'jmpywt5w8',
    scoName: 'j3lfnnoa3',
    spaoName: 'tl6hp7lw6',
    spaoEmail: 'nlmtlfnw2',
    pnpType: '3gf7kfug8',
    pnpTaxExemptVerified: 'ffhkhjzq4',
    pnpTaxExemptLetter: 'hhieq2ug1',
    pnpOpenToPublic: '6tmylkkw8',
    pnpServicesDescription: 'w33gjsyw3',
    pnpCriticalFacility: 'khz1uwoq1',
    procurementPolicyOnFile: '8gks3xgw4',
    forceAccountPolicyOnFile: 'va1biewg1',
    indirectCostRate: 'l2msvu1g3',
    indirectCostRateType: 'hkt727bq1',
    singleAuditRequired: 'gspp7srw1',
    singleAuditCurrent: 'sicdjn4g2',
    bankName: 'a22pmkpg4',
    bankRoutingNumber: 'wtnhxdiq3',
    bankAccountNumber: 'b8d7skjw1',
    bankAccountType: 'vmyvr8sw2',
    contactEmails: 'w8apg72g7',
    status: 'usdqlosq1',
    notes: 'tqcrtmaw7',
  },
  paDisasters: {
    incidentId: 'fekrzfwa5',
    disasterNumber: 'dezyemag2',
    disasterName: 'vwstrvna3',
    declarationType: 'ntytczpq4',
    declarationDate: 'hu1a4vmw7',
    incidentType: 'xmdvj4xw6',
    incidentPeriodStart: '6c4dpq0a3',
    incidentPeriodEnd: 'hggrn23g7',
    state: 'flidkmdq5',
    designatedCounties: '08gunbjg3',
    paDesignatedAreas: 'isjl0aua2',
    federalSharePct: 'dejh7rpa6',
    emergencyWorkDeadline: 'nehlgsfa1',
    permanentWorkDeadline: 'zvekjtgg7',
    largeProjectThreshold: '3qieldfg1',
    smallProjectMinimum: '32fmqd4g5',
    perCapitaIndicator: '1grey7ug7',
    countyPerCapita: '4sxsdj4a3',
    programDeliveryManagerName: 'jlsthxxq3',
    programDeliveryManagerEmail: 'nmhptpna2',
    programDeliveryManagerPhone: 'xvhyausw7',
    femaRegion: 'ugyzrqbw6',
    cfda: 'exmbhqca7',
    status: 'f1lojjdw5',
    notes: '4fofdhvg7',
  },
  paDamageInventory: {
    organizationId: 'tozaow3q5',
    disasterId: 'nug5kh0g6',
    facilityName: 'xvqkqvoa6',
    facilityType: '2u4mh0tg3',
    category: 'j3wjvt6w1',
    siteAddress: '3zlkc0ow5',
    siteCity: '29kcgehg2',
    siteCounty: 'icc6uw2q6',
    siteState: '7sts5qaq5',
    siteZip: 'ydp83k0g6',
    lat: 'aagvyxrq6',
    lng: 'tnfmlg9a1',
    preDisasterCondition: 'ioeo3lkg6',
    preDisasterUse: 'tamejaqa7',
    damageDescription: 'rf7lzgta2',
    damageCause: 'ykc77dqw7',
    damageSeverity: 'pgm6qcyg3',
    estimatedCost: 'qjvekk0q2',
    dimensions: '18ky7tqw5',
    workStatus: '9n8kzmpw2',
    siteInspected: 'jpi16hfa1',
    siteInspectionDate: 'qy25ztea4',
    siteInspectorName: 'meqkjddq8',
    siteInspectorOrg: 'uuctxmjg3',
    projectId: 'j6sj5ela6',
    impactAssessmentId: 'ftvzgtyq2',
    status: 'cbcfblpw2',
    ineligibleReason: '5zdmgska4',
    photos: 'lsumdr8a8',
    notes: 'ti4sf1xg4',
  },
  paProjects: {
    organizationId: 'as8npcgw6',
    disasterId: 'rrguo7ma5',
    projectNumber: 'w3av3zfg3',
    projectTitle: 'ca5h2ewg3',
    category: '87b08tvw7',
    projectSize: 'lkvthybw7',
    workType: 'uzvvibuw6',
    projectAddress: 'ty8t4xmg8',
    projectCity: 'o6ilbsea6',
    projectCounty: '749iu5fw4',
    projectState: 'etip4l8g4',
    projectZip: '6fj04f8a4',
    projectLat: 'gk10c8wq1',
    projectLng: 'umztcclq8',
    damageDescription: 'nonnk5bg7',
    scopeOfWork: 'o06ipc5q6',
    costNarrative: 'aflh6atg6',
    estimatedCost: 'un19i3fw3',
    actualCost: 'tgf6bc2q6',
    federalSharePct: 'flleauaq1',
    federalShareAmount: 'reo96vja6',
    applicantShareAmount: 't1c9nakq1',
    insuranceDeduction: 'x3iyysda2',
    netEligibleCost: 'r0ndfg1w1',
    obligatedAmount: 'xk6kk4vg8',
    drawdownAmount: 'rp3rzg8a8',
    pendingReimbursement: 'ibq4eaca3',
    hazardMitigationIncluded: '2dvuczqa7',
    hazardMitigationCost: 'xvhohvmw5',
    hazardMitigationDescription: 'u4g8vf8q1',
    hazardMitigationBca: 'tcxwwnuw4',
    repairOrReplace: 'yb0e8mwa1',
    improvedProjectElection: 'ebl0mgha8',
    improvedProjectDescription: 'kcrvx0ha7',
    preApprovalRequired: 'skj6cdtq6',
    preApprovalStatus: 'n7fi6low1',
    completionPctEstimate: 'yqiq30kg8',
    completionDate: '0ekfryag3',
    workStartDate: 'gc4joldq2',
    deadline: '8ynpm1ig5',
    extensionRequested: 'y7jnqlzg4',
    extensionNewDeadline: 'bo430jyw6',
    extensionJustification: 'mwc1moag1',
    phase: 'icjbxkeg3',
    status: '2k4q827q2',
    versionNumber: 'av5nh9sw4',
    assignedSpecialist: 'ixjc0hdw7',
    femaProjectId: 'untndgog1',
    cefRequired: 'icaklouq7',
    certLegalResponsibility: 'mwjxk91q6',
    certInsuranceCompliance: '7sccsbjg1',
    certProcurementCompliance: 'e1iwtvog1',
    certNoWorkDuplication: '3zufczwg1',
    certSignedBy: 'oipe4pna7',
    certSignedDate: 'f2lbytvw5',
    notes: 'd5zo7ufa3',
    creatorId: 'gq5vrwaq1',
    createdDate: 'safenfbq2',
    lastModifiedBy: 'oi1dy3lq5',
    lastModifiedDate: 'xtji56lg7',
  },
  paProjectCosts: {
    projectId: 'n7ipc1qw4',
    costType: 'etmjuumw4',
    cefPart: 'mhx1i8cw3',
    description: 'iueytylq8',
    quantity: 'yyccwmwg5',
    unit: 'yfeyrmag5',
    unitCost: 'moirodxa4',
    totalCost: 'pwwvwz9a2',
    csiCode: 'anxnggpa2',
    sourceReference: 'r8ypxiuw5',
    estimatedOrActual: 'jdrcchkw7',
    eligible: 'ky0jvveq6',
    ineligibleReason: 'bivjkkig6',
    linkedRecordId: 'zdiurh5a6',
    notes: 'qf910zga7',
  },
  paForceAccountLabor: {
    projectId: 'l9g02mzq8',
    organizationId: 'ssluk4mq8',
    employeeName: 'jqgk3flq2',
    employeeTitle: 'wl4woajg6',
    employeeId: 'naevfsza2',
    workDate: 'nqn6su9w6',
    hoursRegular: 'ar1iqbiw1',
    hoursOvertime: 'pygdvnjq4',
    rateRegular: 'rmdcowcw5',
    rateOvertime: '5gjbhama6',
    fringeBenefitsPct: 'critvrhg3',
    fringeFica: '6kvnowzg6',
    fringeRetirement: '6hcxccaa4',
    fringeHealth: '7vzic5bw7',
    fringeWorkersComp: '1waehfeg6',
    fringeUnemployment: 'p5t5a9ka5',
    fringeOther: '15pxdjbq5',
    laborCost: 'znfxtqyg5',
    fringeCost: 'jmvgclma7',
    totalCost: 'ui0wdbra5',
    activityDescription: 'bouzknkw3',
    category: 'aiqo29aa1',
    timesheetOnFile: '0vajzolq1',
    notes: 'kvulvriq4',
    incidentId: 'xu09y89a7',
    approvedRegHours: 'salrtmew6',
    approvedOTHours: 'rjnwwuaw8',
    approvedCost: 'hnl9isqg3',
    reviewerNotes: 'dwmvndma7',
    accountCode: 'ny5pkncw1',
    programCode: 'afra3dig8',
    shiftPremium: 'ayftxc9a2',
  },
  paForceAccountEquip: {
    projectId: '7e12itcw3',
    organizationId: 'zp2qt9qw2',
    equipmentType: 'tmftdova4',
    equipmentSize: 'lmgbnn7a3',
    femaEquipCode: 'zbotqksa7',
    horsepower: 't5xe20yg5',
    workDate: '0gz5dnuw8',
    hoursUsed: 'xj03pa1q6',
    femaRate: 'qq7s3itq7',
    applicantRate: '1t8thzqw5',
    hourlyRate: 'btyexcgg1',
    totalCost: 'pupnnshw7',
    operatorIncluded: 'qjoy1otq7',
    operatorName: 'ntajtdba5',
    activityDescription: 'qeidpgaq1',
    notes: 'ta8rvqvw5',
  },
  paMaterials: {
    projectId: '2rukemka6',
    organizationId: 'aenevv2a3',
    materialDescription: 'ano0rstq8',
    vendor: 'o7ffyopq1',
    purchaseDate: 'm0rcgt5w6',
    quantity: 'x5pmecmw4',
    unit: 'amxfx14q4',
    unitCost: 'rooq4wiw4',
    totalCost: 'kqaerhtq2',
    invoiceNumber: 'yaggwgpa4',
    invoiceOnFile: 'x4ty7kda8',
    fromExistingStock: 'ullutsja8',
    stockValuationMethod: 'd8dmysvw8',
    notes: 'l4k3cryw2',
  },
  paContracts: {
    projectId: 'htyjmuiw2',
    organizationId: 'oejctgda4',
    contractorName: 'cw8kft5w5',
    contractorUei: 'i82sjlvg6',
    contractNumber: '54klecsq2',
    contractType: 'zpx2eqcg2',
    procurementMethod: 'eb0rusna4',
    contractAmount: '61lq6xwq1',
    changeOrderCount: 'q4fm6cmw5',
    changeOrderAmount: 'pw6f8jya1',
    totalContractValue: 'nqpfru4q8',
    amountPaid: 'cw71hgzw7',
    retainageHeld: 'm7o2jula2',
    scopeOfWork: 'ibgg1bya1',
    startDate: 'aoacsewg3',
    endDate: 'rutif9fg6',
    costPriceAnalysis: 'w87smysa4',
    conflictOfInterestCheck: '3s0krp7a1',
    davisBaconApplicable: 'rviaqulq1',
    davisBaconCertified: '4z4aejnw5',
    debarmentChecked: 'qec9scva1',
    debarmentCheckDate: 'f9hs8ksq6',
    bondingRequired: 'wmj88xmg8',
    bondAmount: 'nh5idbeq6',
    competitiveBidsReceived: 'ktunxa6q7',
    biddersListOnFile: 'nsbza6pg3',
    contractProvisionsIncluded: 'dsamljqa4',
    procurementDocsOnFile: 'sbqrnkkw1',
    soleSrcJustificationOnFile: '6gvr1ymg1',
    status: 'rgkoia2a8',
    notes: 'oamc7gna5',
  },
  paRentedEquipment: {
    projectId: '8sgc969a6',
    organizationId: 'jkeogtda7',
    equipmentType: 'te8mqrgq1',
    vendor: 'c3utfgkw3',
    rentalAgreementNumber: 'z5rds8sw1',
    rentalStartDate: 'qrviz2wa7',
    rentalEndDate: 'va1puydq5',
    rateType: 'ootze98a8',
    rate: 'u3p3x30g1',
    hoursOrDaysUsed: 'et62k5cq5',
    totalCost: 'fawbl5tg3',
    operatorIncluded: 'v5oqxy5q5',
    invoiceOnFile: 'mmrbjyaa4',
    activityDescription: 'zjvvmgtq2',
    notes: 'iezjcaog7',
  },
  paDonatedResources: {
    projectId: 'rw9e4xyg1',
    organizationId: '2co3qsaa2',
    resourceType: 'gya6xuda5',
    donorName: 'mwbwrkww2',
    donorOrganization: 'vsasemmq1',
    workDate: '8fdjyc8g2',
    hoursWorked: 'pil2nxig6',
    description: 'owfn8sig8',
    estimatedValue: 'yzuzi0tq3',
    signatureOnFile: 'tfy7t2ia7',
    notes: 'sczj84fq8',
  },
  paInsurance: {
    organizationId: 'n2j4y0sa1',
    projectId: 'd4o2bi6q6',
    damageInventoryId: 'gmheff2a7',
    policyNumber: 'bannwkdg3',
    carrier: 'sh4cictq6',
    policyType: 'enshpkma5',
    coverageAmount: 'izwxhurq4',
    deductible: 'iap6mpwg5',
    policyEffectiveDate: 'ybs2oniw4',
    policyExpirationDate: 'xlz9k9xa7',
    claimFiled: 'wvznqyhg2',
    claimNumber: 'pzs51h1w1',
    claimDate: 'opkbvj6q6',
    settlementAmount: 'dzlxq1uw4',
    settlementDate: 'bkqwwniq8',
    denialReceived: 'n4kyuoga4',
    denialReason: '04qbskja2',
    denialLetterOnFile: 'yqkssaxq4',
    anticipatedRecovery: 'c0qctuaq6',
    actualRecovery: 'zyyi4vya8',
    femaDeductionAmount: 'tmgetljg8',
    obtainMaintainRequired: 'ftusebxa4',
    obtainMaintainCommitted: 'wra3lwwg3',
    adjusterReportOnFile: 'dziqpk9a4',
    status: 'u2cbvzxw3',
    notes: 'qyeys1ua4',
  },
  paCompliance: {
    projectId: 'xrspashq2',
    organizationId: 'qqfz312w7',
    nepaRequired: 'djvieeww7',
    nepaLevel: 'lvqzq4rq5',
    nepaStatus: 'fcfpb5xa5',
    nepaCompletionDate: 'r2nwlfzg2',
    section106Required: '8nujgyaa4',
    section106Status: 'b1y1fylg2',
    historicProperty: 'jiceun0w5',
    historicPropertyAge: 'nxywgyoq5',
    shpoConsultation: 'wam1iwrq4',
    tribalConsultation: 'pxinhgkq2',
    indianSacredSites: 'cb866dva7',
    section106CompletionDate: '6fo4xwrq7',
    inFloodplain: 'vyu6tiuw6',
    floodZone: 'kylxsntg6',
    baseFloodElevation: 'y1kp2s6g6',
    floodInsuranceRequired: 'ypkbdhag8',
    floodInsuranceObtained: 'mwucaoqq7',
    eo11988Compliance: '8gi3pmja8',
    esaConsultationRequired: 'wbfxtzka1',
    esaStatus: 'cg1hhqmg4',
    protectedSpeciesPresent: 'pfhb01uq8',
    coastalBarrierArea: 'ymfj9zkw4',
    hazmatPresent: '45wfgwaq7',
    hazmatType: '7ntd3qqa8',
    hazmatMitigationRequired: 'y4uogbka4',
    coastalZone: 'maklh72g3',
    coastalZoneConsistency: 'r5c4zd1g4',
    wetlandsImpacted: 'fr0g5dpw2',
    wetlandsPermitRequired: 'tjyptoyw3',
    overallComplianceStatus: 'n1xgejba1',
    ehpReviewerId: 'yms2z4wa8',
    complianceNotes: 'h3khsr5w4',
  },
  paDocuments: {
    organizationId: 'fuhyeamg1',
    projectId: 'vaxnsh9w6',
    damageInventoryId: 'rbskbmoq7',
    contractId: 'zgpep3ra1',
    insuranceId: 'wqfg4sha1',
    documentName: 'u6xifmvq6',
    documentType: 'hcu23idw1',
    description: 'aw7bdf1q4',
    uploadDate: 'wujvxxea1',
    uploadedBy: 'owzfltpw3',
    fileId: 'qdmual0w6',
    fileSize: 'huuwbewq1',
    mimeType: 'dwevdvqg8',
    geotagLat: 'rjhwiriq1',
    geotagLng: 'xovofxqa1',
    geotagDate: 'xxvwam1w4',
    tags: 'dcr3m1aa1',
    notes: 'oa1aesoa7',
  },
  paTimelineEvents: {
    projectId: 'sa4uclsw1',
    organizationId: 'l6ly1ilw5',
    disasterId: 'ls27ystw3',
    eventType: '9fmzhd6q1',
    eventDate: 'a069qcwa5',
    dueDate: 'qbonpoea7',
    completedDate: 'zygiuora2',
    description: 'afe0p06w7',
    creatorId: 'zoy0epdg5',
    status: 'snhwt3fg3',
    notes: 'imttijfg5',
  },
  paNotes: {
    parentType: 'jcx5haoq7',
    parentId: 'gsa7tmvg7',
    organizationId: 'phnljhaw7',
    noteType: 'lrkhueig6',
    content: 'olqyzw6a6',
    creatorId: 'paitjqfq2',
    createdDate: '0rsd61wa3',
    visibility: 'bommfoyq3',
  },

  // ── PA Time Extensions ──
  paTimeExtensions: {
    projectId: 'waougpeq8',
    organizationId: 'gmaovdvg3',
    disasterId: 'n6dcq32g4',
    requestDate: 'bmirqazg6',
    currentDeadline: 'aw9b6cxq6',
    requestedNewDeadline: 'pfzrkyiq8',
    extensionMonths: 'kymci9iq4',
    recipientName: 'ygorstua8',
    recipientTitle: 'nnga7wka5',
    recipientOrg: 'k0iycreg3',
    recipientAddress: 'qhwnc34q7',
    justification: 'e7opii8g8',
    supportingCircumstances: 'tpznhkpq8',
    letterContent: 'c0offqvq6',
    status: 'jd2jl3kq1',
    approvalDate: 'v4cgu6ga8',
    approvedBy: 'kv0tfg9q2',
    approvedNewDeadline: 'tnmrbhow3',
    createdBy: 'unmlmopa4',
    notes: '76un73ow7',
  },
  // ── PA Reimbursement Requests ──
  paReimbursementRequests: {
    projectId: '802sboeq8',
    organizationId: 'sg3y7u3a3',
    disasterId: 'jv3f6elq4',
    requestNumber: 'km1o1c6a7',
    requestDate: 'qeyitmqa3',
    periodStart: 'nh3dr99w1',
    periodEnd: 'lnexba1q7',
    requestedAmount: '3ktyz1pq1',
    federalShare: 'ny0kclow7',
    applicantMatch: 'qv06iwhg6',
    costBreakdown: 'aitzuadg5',
    supportingDocIds: 'eskag5vq4',
    submittedBy: 'zle9knoa5',
    submittedDate: 'njjtk25q2',
    status: '47x2hz9a3',
    reviewedBy: 'rm4osvow8',
    reviewDate: 'yqhqfd1g3',
    reviewNotes: 'v1d2jk0a7',
    approvedAmount: 'skgphqcw8',
    paymentDate: '6mowzf0a6',
    paymentReference: 'ggpy3jmq4',
    notes: 'zm7hqdza8',
  },

  // ── PA Labor Employees (Force Account) ──
  paLaborEmployees: {
    employeeName: '6g4es81q1',
    employeeId: '2hxtw1ya1',
    jobTitle: '2ywisvuq2',
    department: 'myz7ecla7',
    employmentType: 'odjfd9qq4',
    flsaStatus: 'nkqiglwg2',
    budgetStatus: 'rlvmedvg8',
    regularRate: 'im8qajla8',
    overtimeRate: 'ugb2tbgq2',
    fringeFicaPct: 'rngx01kq4',
    fringeRetirementPct: 'nic0cpsg8',
    fringeHealthPct: 'blgu8qkq8',
    fringeWorkersCompPct: 'svpqth5w1',
    fringeUnemploymentPct: '7onjrziq1',
    fringeOtherPct: '5s3m5u5w5',
    totalFringePct: 'mvkwg7ga5',
    fringeHourlyRate: 'd0z0mpta7',
    totalHourlyRate: '5wpib4la4',
    payPolicyRef: 'eijo7rfq7',
    hireDate: 'ybpd6aeq6',
    normalWeeklyHours: 'ujott45a1',
    rosterEmail: '7wabqjha7',
    organizationId: 'jvg9arjw1',
    status: 'icqi349g1',
    notes: 'wirgwafg6',
    defaultAccountCode: 'otyqt4zg4',
    defaultProgramCode: 'c5iss9sq5',
  },

  // ── PA Checklist Templates ──
  paChecklistTemplates: {
    itemKey: 's8jvohzw4',
    label: 'zobq4seq4',
    category: '3yypbqgg5',
    description: 'iykjw7cq5',
    required: 'wxjfbm9a7',
    sortOrder: '84rcsamg3',
    isActive: 'p2ynwppw6',
    programType: '72xljf4q6',
  },

  // ── Workflows ──
  workflowTemplates: {
    name: 'gn39tdna5',
    description: 'nqurclgg6',
    module: 'f1mk521g2',
    triggerTable: 's7whskfa5',
    triggerField: 'a7dmndpa3',
    triggerValue: 'tdnntobq6',
    triggerType: 'gdzycz9g6',
    stepsJson: 'tvmgnd5g5',
    active: 'qtsjle9a8',
    category: 'dpgdifrg7',
    priority: '7jcdyziq7',
    creatorId: 'imfjkk3w3',
    notes: 'zsc8u2ia5',
  },
  workflowInstances: {
    templateId: '2d7etw8g2',
    templateName: 'q7k0wuxg7',
    sourceModule: 'wl7x7piq4',
    sourceTable: 'zvny6wqa7',
    sourceRecordId: '6lb0m9zg1',
    sourceRecordLabel: 'amvhwdta2',
    currentStepIndex: 'yufq9c2w4',
    totalSteps: 'erfsgv2a8',
    status: 's5rql66g8',
    priority: 'gvjvgx1a1',
    startedAt: 'dhzieb9g6',
    completedAt: 'h49ad3qg5',
    startedBy: 'a31ttgww4',
    contextJson: 'ernsgmgg1',
    notes: 'tq1xenmq3',
  },
  workflowSteps: {
    instanceId: 'u9yycg7w7',
    stepIndex: 'zljy6z4w4',
    stepName: 'ldbgieua8',
    stepType: 'cpzehu6g8',
    assigneeType: 'j1350beg1',
    assignee: '8ssrwyew5',
    assigneeName: '59x2xjkq4',
    status: 'bofq2xaa4',
    dueDate: 'y1zoprxw1',
    completedBy: 'lqqbj8kq3',
    completedAt: 'rbrrsxeg2',
    outcome: 'tljkq3gg3',
    comments: 'a1ye69mw8',
    notifyChannels: 'yhppdcmg7',
    escalationHours: 'eniojkbg5',
    escalationAction: '47boz2ba8',
    escalationTarget: '6fyfy77w1',
    configJson: 'zyf6rtla1',
    signatureData: 'ib7xrvbw8',
    notes: 'nnvdemla1',
  },
  formTemplates: {
    templateName: 'px5n4b9a5',
    description: 'xe0qyjfa3',
    schema: 'eqkkc2xa7',
    status: 'jhwwutmq1',
    module: 'hipaahmq4',
    incidentId: 'osntf7nw7',
    isPublic: 'edcv8meq8',
    publicSlug: 'nml07kew1',
    creatorName: 'etjhpsfq4',
    responseCount: '5xamkiyg5',
  },
  formResponses: {
    templateId: 'k1aceo8a1',
    templateName: 'b81hp1sg1',
    incidentId: 'lmmosesg5',
    respondentName: 'm8eoy3jq8',
    respondentEmail: 'rle3gzzw8',
    responseData: '1o79p76w1',
    status: 'lgvl75gg1',
    submittedAt: 'ivcj48aa6',
    sourceModule: 'us3tgpfw3',
    notes: 'jxfhf1ra2',
  },
} as const;

// ── Headers ────────────────────────────────────────────────────
function headers(token?: string): Record<string, string> {
  const h: Record<string, string> = {
    'Content-Type': 'application/json',
    'Origin': ORIGIN,
  };
  if (token) h['Authorization'] = `Bearer ${token}`;
  return h;
}

// ── Parse Ignatius table response ────────────────────────────
// Ignatius returns array-of-arrays: [headers, ...rows]
// Headers are like "TableName - Field Name" → convert to camelCase
function parseTableData(data: unknown): Record<string, unknown>[] {
  if (!Array.isArray(data) || data.length === 0) return [];
  const rawHeaders = data[0] as string[];
  const rows = data.slice(1) as string[][];

  // Convert "Incidents - Start Date" → "startDate", "id" → "id"
  const keys = rawHeaders.map((h: string) => {
    const parts = h.split(' - ');
    const name = parts.length > 1 ? parts.slice(1).join(' - ') : parts[0];
    return name
      .split(' ')
      .map((w, i) => {
        const lo = w.toLowerCase();
        return i === 0 ? lo : lo.charAt(0).toUpperCase() + lo.slice(1);
      })
      .join('');
  });

  return rows.map(row => {
    const obj: Record<string, unknown> = {};
    keys.forEach((key, j) => { obj[key] = row[j] ?? ''; });
    return obj;
  });
}

// ── Generic API helpers ────────────────────────────────────────

export async function fetchTable<T = Record<string, unknown>>(
  tableKey: string,
  options?: { limit?: number; token?: string }
): Promise<T[]> {
  const limit = options?.limit ?? 1000;
  const resp = await fetch(
    `${API}/api/Report/getalldata?tableId=${tableKey}&limit=${limit}`,
    { headers: headers(options?.token) }
  );
  if (!resp.ok) throw new Error(`fetchTable ${tableKey}: ${resp.status}`);
  const raw = await resp.json();
  return parseTableData(raw) as T[];
}

// ── Workflow record-event hook ────────────────────────────────
// The workflow store registers a listener at startup so every record
// create/update/delete fires a workflow trigger candidate without
// requiring per-store wiring. fields/data are passed as a plain object
// for the workflow editor's field-filter logic.
type RecordEventListener = (
  tableKey: string,
  event: 'create' | 'update' | 'delete',
  rid: number,
  data: Record<string, unknown>,
  previousData?: Record<string, unknown>,
) => void;
let _recordEventListener: RecordEventListener | null = null;
export function registerRecordEventListener(fn: RecordEventListener) {
  _recordEventListener = fn;
}
function fieldsToObject(fields: Array<[string, string]>): Record<string, unknown> {
  // The fields here are [fieldKey, value] tuples where fieldKey is the
  // Ignatius column key, not the camelCase name. The workflow store's
  // listener reverse-maps these to camelCase using the FIELDS schema
  // before passing them to the workflow trigger logic.
  const o: Record<string, unknown> = {};
  for (const [k, v] of fields) o[k] = v;
  return o;
}
function emitRecordEvent(
  tableKey: string,
  event: 'create' | 'update' | 'delete',
  rid: number,
  data: Record<string, unknown>,
  previousData?: Record<string, unknown>,
) {
  if (!_recordEventListener) return;
  try { _recordEventListener(tableKey, event, rid, data, previousData); } catch { /* ignore */ }
}

export async function createRecord(
  tableKey: string,
  fields: Array<[string, string]>,
  token?: string
): Promise<number> {
  // POST max 10 fields, then PUT the rest
  const first10 = fields.slice(0, 10);
  const rest = fields.slice(10);

  const resp = await fetch(`${API}/api/FormAction/postdata`, {
    method: 'POST',
    headers: headers(token),
    body: JSON.stringify({
      ApplicationTableKey: tableKey,
      FieldsList: first10.map(([Key, Value]) => ({ Key, Value: String(Value ?? '') })),
    }),
  });
  if (!resp.ok) throw new Error(`createRecord: ${resp.status}`);
  const data = await resp.json();
  const rid = data?.Rid ?? data?.recordId;
  if (!rid) throw new Error('createRecord: no Rid returned');

  if (rest.length > 0) {
    await fetch(`${API}/api/FormAction/putdata`, {
      method: 'PUT',
      headers: headers(token),
      body: JSON.stringify({
        ApplicationTableKey: tableKey,
        FieldsList: rest.map(([Key, Value]) => ({ Key, Value: String(Value ?? '') })),
        Where: { Rid: Number(rid) },
      }),
    });
  }

  emitRecordEvent(tableKey, 'create', Number(rid), fieldsToObject(fields));
  return Number(rid);
}

export async function updateRecord(
  tableKey: string,
  rid: number,
  fields: Array<[string, string]>,
  token?: string,
  /** Optional snapshot of the record BEFORE the update — passed through
   *  to the workflow record-event listener so delta operators
   *  (changed_to / changed_from / changed) can compare values. */
  previousData?: Record<string, unknown>,
): Promise<void> {
  const resp = await fetch(`${API}/api/FormAction/putdata`, {
    method: 'PUT',
    headers: headers(token),
    body: JSON.stringify({
      ApplicationTableKey: tableKey,
      FieldsList: fields.map(([Key, Value]) => ({ Key, Value: String(Value ?? '') })),
      Where: { Rid: rid },
    }),
  });
  if (!resp.ok) throw new Error(`updateRecord: ${resp.status}`);
  emitRecordEvent(tableKey, 'update', rid, fieldsToObject(fields), previousData);
}

export async function deleteRecord(
  tableKey: string,
  rid: number,
  token?: string
): Promise<void> {
  const resp = await fetch(`${API}/api/FormAction/deleteobject`, {
    method: 'DELETE',
    headers: headers(token),
    body: JSON.stringify({
      ApplicationTableKey: tableKey,
      Where: { Rid: rid },
    }),
  });
  if (!resp.ok) throw new Error(`deleteRecord: ${resp.status}`);
  emitRecordEvent(tableKey, 'delete', rid, {});
}

// ── Claude AI ──────────────────────────────────────────────────

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function callClaude(
  messages: Array<{ role: string; content: string | any[] }>,
  options?: { system?: string; maxTokens?: number; stream?: boolean }
): Promise<string> {
  const resp = await fetch(`${WORKER_URL}/api/claude`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Origin': ORIGIN },
    body: JSON.stringify({
      model: 'claude-sonnet-4-6',
      max_tokens: options?.maxTokens ?? 4096,
      system: options?.system,
      messages,
      stream: options?.stream ?? false,
    }),
  });
  if (!resp.ok) {
    const errText = await resp.text().catch(() => '');
    const errMsg = errText ? JSON.parse(errText)?.error?.message || errText.substring(0, 200) : '';
    throw new Error(`Claude API ${resp.status}: ${errMsg}`);
  }
  const data = await resp.json();
  return data?.content?.[0]?.text ?? '';
}

// ── Auth ───────────────────────────────────────────────────────

// ── User Management ──────────────────────────────────────────

export interface IgnatiusUser {
  id: string;
  email: string;
  fullName: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  role: string;
  topLevelRole: string;
  isAdmin: boolean;
  active: boolean;
  lastLogin: number;
}

export async function fetchIgnatiusUsers(): Promise<IgnatiusUser[]> {
  const resp = await fetch(`${WORKER_URL}/api/users`, {
    headers: { 'Content-Type': 'application/json', 'Origin': ORIGIN },
  });
  if (!resp.ok) throw new Error(`Fetch users: ${resp.status}`);
  return resp.json();
}

export async function validateEmail(email: string): Promise<unknown> {
  const resp = await fetch(`${WORKER_URL}/api/users/validate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Origin': ORIGIN },
    body: JSON.stringify({ email }),
  });
  if (!resp.ok) throw new Error(`Validate email: ${resp.status}`);
  return resp.json();
}

export async function createIgnatiusUser(data: {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  password: string;
  role?: string;
  isExternal?: boolean;
}): Promise<{ success: boolean; data: unknown }> {
  const resp = await fetch(`${WORKER_URL}/api/users/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Origin': ORIGIN },
    body: JSON.stringify(data),
  });
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error((err as Record<string, string>).error || `Create user: ${resp.status}`);
  }
  return resp.json();
}

export async function resetUserPassword(email: string, newPassword: string, adminToken: string): Promise<{ success: boolean }> {
  // 1. Fetch the RSA public key from Ignatius
  const keyResp = await fetch('https://api.ignatius.io/api/user/publickey');
  if (!keyResp.ok) throw new Error('Failed to fetch encryption key');
  let pemKey = await keyResp.text();
  // Strip JSON quotes if present
  pemKey = pemKey.replace(/^"|"$/g, '').replace(/\\n/g, '\n');

  // 2. Import the public key for RSA-OAEP encryption
  const pemBody = pemKey
    .replace('-----BEGIN PUBLIC KEY-----', '')
    .replace('-----END PUBLIC KEY-----', '')
    .replace(/\s+/g, '');
  const keyBytes = Uint8Array.from(atob(pemBody), c => c.charCodeAt(0));
  const publicKey = await crypto.subtle.importKey(
    'spki', keyBytes, { name: 'RSA-OAEP', hash: 'SHA-256' }, false, ['encrypt'],
  );

  // 3. Encrypt the password
  const encoded = new TextEncoder().encode(newPassword);
  const encrypted = await crypto.subtle.encrypt({ name: 'RSA-OAEP' }, publicKey, encoded);
  const encryptedB64 = btoa(String.fromCharCode(...new Uint8Array(encrypted)));

  // 4. Call Ignatius resetpassword with admin's own Bearer token
  const resp = await fetch('https://api.ignatius.io/api/user/resetpassword', {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + adminToken,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      NewPassword: encryptedB64,
      AppId: '3to4deeg3',
      Email: email,
    }),
  });
  if (!resp.ok) {
    const errText = await resp.text();
    throw new Error(errText || `Reset failed: ${resp.status}`);
  }
  return { success: true };
}

// ── Auth ───────────────────────────────────────────────────────

export async function loginUser(email: string, password: string) {
  const resp = await fetch(`${WORKER_URL}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Origin': ORIGIN },
    body: JSON.stringify({ email, password }),
  });
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.error || `Login failed: ${resp.status}`);
  }
  return resp.json();
}
